import React, { useContext } from "react";
import styled from "styled-components";
import { EventContext, AnalyticsContext } from "Components";
import ReactHtmlParser from "react-html-parser";
import { fonts } from "theme/fonts";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
library.add(fas, fab, far);

export const Header = ({
  showHeader,
  registration,
  preCampaign,
  setModalVisible,
}) => {
  const { event } = useContext(EventContext);
  const { logClick } = useContext(AnalyticsContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  const { 0: brand, 1: secondary } = event.logos;

  let brandLogo = `${api}/o/${storageDirectory}%2F${brand.path}?alt=media`;
  let secondaryLogo = `${api}/o/${storageDirectory}%2F${secondary.path}?alt=media`;
  let headerBg = `${api}/o/${storageDirectory}%2F${event.header.background}?alt=media`;

  const {
    heading: ctaHeading,
    video: ctaVideo,
  } = event.callToActions.heroVideo;

  const logoClickHandler = (link) => {
    logClick({
      label: "Header Logo",
      url: link,
    });
  };

  return (
    <>
      {showHeader && (
        <HeaderWrapper as="header" registration={registration}>
          <HeaderContainer preCampaign={preCampaign}>
            {preCampaign && (
              <Link
                href={brand.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => logoClickHandler(brand.link)}
              >
                <PrimaryLogo src={brandLogo} />
              </Link>
            )}

            {registration && (
              <>
                <HeaderRegRight bgImage={headerBg}>
                  <h1>{ReactHtmlParser(event.header.heading)}</h1>
                  <HeaderCTA onClick={() => setModalVisible(true, ctaVideo)}>
                    {ctaHeading}
                    <PlayIcon>
                      <FontAwesomeIcon icon={["far", "play-circle"]} />
                    </PlayIcon>
                  </HeaderCTA>
                </HeaderRegRight>

                {event.header.callOut && (
                  <HeaderCallOut>
                    {ReactHtmlParser(event.header.callOut)}
                  </HeaderCallOut>
                )}
              </>
            )}
          </HeaderContainer>
        </HeaderWrapper>
      )}
    </>
  );
};

const HeaderCallOut = styled.div`
  width: 100%;
  color: #ffffff;
  padding: 10px 15px;
  background: rgb(69 128 221 / 100%);
  font-size: 12px;

  span:nth-of-type(1) {
    text-transform: uppercase;
    font-family: ${fonts.header};
  }

  span:nth-of-type(2) {
    font-family: ${fonts.brand.regularItalic};
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    position: absolute;
    top: 0;
    right: 0;
    width: unset;
    background: rgb(69 128 221 / 75%);
  }

  @media only screen and ${(props) => props.theme.maxMedia.large} {
    width: 10%;
    text-align: center;
    line-height: 1.25;

    span {
      display: block;
    }

    span:nth-of-type(1) {
      font-size: clamp(12px, 1vw, 18px);
    }
  }
`;

const HeaderWrapper = styled.header`
  z-index: 1;
  display: flex;
  flex-direction: row;
  background-color: #00274e;
`;

const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  flex: 1;
  ${(props) => props.preCampaign && `padding: 25px 35px;`}

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
    padding-left: 65px;
    ${(props) => props.preCampaign && `padding: 50px 65px;`}
  }
`;

const Link = styled.a``;

const Logo = styled.img`
  width: 100%;
  display: flex;
`;

const PrimaryLogo = styled(Logo)`
  width: 100%;
  max-width: 100px;
  margin-bottom: -75px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    margin-bottom: -115px;
    max-width: 125px;
  }
`;

const HeaderRegRight = styled.div`
  position: relative;
  color: #ffffff;
  width: 100%;
  padding: 15px 15px 30px;
  ${(props) =>
    props.bgImage &&
    `
    background-image: url(${props.bgImage});
    background-position: top right;
    background-size: cover;
  `}

  h1 {
    font-size: 18px;
    font-family: ${fonts.brand.medium};

    span:nth-of-type(1) {
      display: flex;
    }

    span:nth-of-type(2) {
      display: flex;
      font-size: 28px;
    }

    span:nth-of-type(3) {
      font-family: ${fonts.brand.light};
    }
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 50px 40px 30px 540px;
    flex: 1;
  }
`;

const HeaderCTA = styled.div`
  color: #ffffff;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  z-index: 0;
  padding: 5px 15px 5px 30px;
  font-size: 12px;
  cursor: pointer;

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(69 128 221 / 75%);
    transform-origin: 0 100%;
    transform: skew(-45deg);
    z-index: -1;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 5px 15px 5px 35px;
    font-size: 14px;
  }
`;

const PlayIcon = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;

  path {
    stroke: #ffffff;
  }
`;
